<template>
  <div class="pageBackground">
    <language-picker class="pageBackground__languagePicker" />
    <img
      class="pageBackground__background"
      src="@/assets/images/layout/img-fond.jpg"
    />
    <img
      class="pageBackground__logo"
      src="@/assets/images/layout/logo-blanc.png"
    />
    <img
      class="pageBackground__img"
      src="@/assets/images/layout/image-opacity.png"
    />
    <div class="pageBackground__form">
      <div class="pageBackground__card">
        <div class="pageBackground__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguagePicker from '@/components/ui/LanguagePicker'

export default {
  name: 'PageBackground',
  components: {
    LanguagePicker
  }
}
</script>

<style lang="scss" scoped>
$c: '.pageBackground';

#{$c} {
  background-color: #f5f5f5;
  min-height: 100vh;
  position: relative;

  &__languagePicker {
    position: absolute;
    top: 10px;
    right: 15px;
    z-index: 105;
  }

  &__background {
    display: none;
    height: 100%;
    object-fit: cover;
    border-radius: 0px 40px 40px 0px;
    position: absolute;
    top: 0;
    left: 0;

    @include respond-above(sm) {
      display: block;
      width: 50vw;
    }
    @include respond-above(md) {
      width: 60vw;
    }
    @include respond-above(lg) {
      width: 70vw;
    }
  }

  &__logo {
    padding: 5px;
    height: 65px;
    width: auto;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 105;
    @include respond-above(sm) {
      padding: 30px;
      height: 130px;
    }
  }

  &__img {
    display: none;
    position: absolute;
    top: calc((100% - 400px) / 2);
    left: 0;
    height: 400px;
    @include respond-above(sm) {
      display: block;
    }
  }

  &__form {
    height: auto;
    width: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;

    @include respond-above(sm) {
      width: 400px;
      transform: translateX(45vw); /*IE*/
      transform: translateX(calc(50vw - 75px));
      padding: 60px 0;
    }
    @include respond-above(md) {
      transform: translateX(55vw); /*IE*/
      transform: translateX(calc(60vw - 75px));
    }
    @include respond-above(lg) {
      transform: translateX(65vw); /*IE*/
      transform: translateX(calc(70vw - 75px));
    }
  }

  &__card {
    background-color: white;
    width: 100%;
    z-index: 100;

    @include respond-above(sm) {
      border-radius: 35px;
      width: 400px;
    }
  }
}
</style>
